export default __webpack_public_path__ + "static/media/business-intelligence.bc56a686.svg";